import { createOfflinePlayerId } from './buildLocalGuestPlayer';

/**
 * Local session partnership for Offline mode. Client UUID is only used as the
 * React key; flush creates/reactivates the pair via create_session_partnership.
 */
export function buildLocalSessionPartnership(player1Id, player2Id, { id } = {}) {
  return {
    id: id || createOfflinePlayerId(),
    player1Id,
    player2Id,
    createdAt: new Date().toISOString(),
  };
}

export function findLocalPartnershipConflict(partnerships, player1Id, player2Id) {
  const list = partnerships || [];
  const samePair = list.find(
    (p) =>
      (p.player1Id === player1Id && p.player2Id === player2Id) ||
      (p.player1Id === player2Id && p.player2Id === player1Id)
  );
  if (samePair) {
    return { kind: 'already_active', partnership: samePair };
  }

  const blocking = list.find(
    (p) =>
      p.player1Id === player1Id ||
      p.player2Id === player1Id ||
      p.player1Id === player2Id ||
      p.player2Id === player2Id
  );
  if (!blocking) return null;

  const playerId =
    blocking.player1Id === player1Id || blocking.player2Id === player1Id
      ? player1Id
      : player2Id;
  const existingPartnerId =
    playerId === blocking.player1Id ? blocking.player2Id : blocking.player1Id;

  return {
    kind: 'already_partnered',
    conflict: {
      playerId,
      existingPartnerId,
      existingPartnershipId: blocking.id,
      partnership: blocking,
    },
  };
}
